<template>
    <div class="flex items-start gap-3 py-3 w-full px-3 lg:px-6 cursor-pointer hover:bg-a-brown-ebdac1"
        @click="clickItem()">
        <div class="flex-none">
            <img v-show="isShowIconFood" src="@/assets/noti/ic-order-placed.svg" />
            <img v-show="!isShowIconFood" src="@/assets/noti/ic-logo-bk.svg" />
        </div>
        <div class="flex-auto">
            <div class="msg font-bold text-14 lg:text-base line-clamp-2"
                :class="[isReaded ? 'text-a-brown-9f8273' : 'text-a-brown-502314']">
                {{ msg }}
            </div>
            <div class="dt mt-1 text-a-brown-9f8273 text-14 lg:text-base">
                {{ formatDate }}
            </div>
        </div>
        <div class="flex-none">
            <div v-if="!isReaded">
                <div class="w-2.5 h-2.5 rounded-full bg-a-orange-ff8732"></div>
            </div>
        </div>
    </div>
</template>
<script>
import { inject, ref } from 'vue'
// helper
import useNotificationModal from '@/helper/composable/modal/useNotificationModal'
import DatetimeHelper from '@/helper/DatetimeHelper'
import { NotificationType } from '@/helper/StaticValue'
import Utility from '@/helper/Utility'
//service
import { CampaignConfigBuilder } from '@/core/Campaign/config/CampaignConfigModel';
import BzbsCampaign from '@/core/Campaign/service/BzbsCampaign.js';
//mixin
import ModalMixin from "@/mixin/ModalMixin.js";

export default {
    name: 'NotificationItem',
    mixins: [ModalMixin],
    props: {
        item: {
            type: Object
        }
    },
    components: {},
    emits: [],
    data: function () { return {} },
    computed: {
        isReaded: function () {
            return this.item.isRead
        },
        isOrder: function () {
            return this.item.type == NotificationType.Campaign
        },
        isShowIconFood: function () {
            let msg = this.item?.message ?? ""
            let foodRegex = /^\(food\)/
            if (foodRegex.test(msg)) {
                
                return true
            }
            return false
        },
        formatDate: function () {
            return DatetimeHelper.dateShortFormat2(this.item.createTime)
        }
    },
    setup: function (props) {
        const modalStore = inject("ModalStore")
        const SideMenuStore = inject("SideMenuStore")
        const NotificationStore = inject("NotificationStore")
        const { notificationModal } = useNotificationModal(modalStore)
        const msg = ref("")

        const init = () => {
            let message = props.item.message ?? ""
            // Remove (food) prefix if present
            if (/^\(food\)/.test(message)) {
                message = message.replace(/^\(food\)/, "").trim()
            }
            msg.value = message
            
            if (props.item.type == NotificationType.Badge && props.item.object) {
                switch (props.item.object.id) {
                    case "BurgerKing_Minimum_Purchase":
                    case "BurgerKing_Buy_from_Specific_Category":
                    case "BurgerKing_Buy_Specific_Item":
                    case "BurgerKing_Ordered_X_Times_per_Day_Month":
                    case "BurgerKing_Accumulate_Purchase_by_Day_Month":
                    case "BurgerKing_Purchase_at_Date_and_Time":
                        msg.value = props.item.object.fb_description ? props.item.message : props.item.object.auto_redeem?.Name
                        break;
                    default:
                        msg.value = ''
                        break;
                }
            }
        }

        init()

        return {
            notificationModal,
            SideMenuStore,
            NotificationStore,
            msg
        }
    },
    methods: {
        clickItem: function () {

            this.SideMenuStore.methods.toggleSideMenu("notification", false);
            this.NotificationStore.methods.sendRead(this.item.rowKey).subscribe({
                next: () => {
                    // update notification
                    this.NotificationStore.methods.getNotifications()
                },
                error: (err) => {
                    console.log(err)
                    // do nothing
                }
            })

            // settimeout because wait sidemenu animation is end to remove body class not-scroll
            setTimeout(() => {
                console.log(this.item);
                if (this.item.type == NotificationType.Message) {
                    this.tracking.event('notification','click notification list', this.item.message ,'Notification type message');

                    // show popup messages
                    this.notificationModal
                        .clearModal()
                        .show(this.item.type, { message: this.item.message })
                        .subscribe((result) => {
                            console.log(result)
                        })
                } else if (this.item.type == NotificationType.Badge && !this.item.isEarnReward) {
                    if (this.item.object.auto_redeem) {
                        switch (this.item.object.id) {
                            case "BurgerKing_Minimum_Purchase":
                            case "BurgerKing_Buy_from_Specific_Category":
                            case "BurgerKing_Buy_Specific_Item":
                            case "BurgerKing_Ordered_X_Times_per_Day_Month":
                            case "BurgerKing_Accumulate_Purchase_by_Day_Month":
                            case "BurgerKing_Purchase_at_Date_and_Time":
                                this.notificationModal
                                    .clearModal()
                                    .setCampaign(this.item.object.auto_redeem)
                                    .show('BadgeCampaign')
                                    .subscribe((result) => {
                                        console.log(result)
                                    })
                                break;
                            default:
                                // Show popup to detail
                                this.notificationModal
                                    .clearModal()
                                    .show(this.item.type, { message: this.item.message }, this.item.isEarnReward)
                                    .subscribe((result) => {
                                        console.log(result)
                                    })
                                break;
                        }
                    } else {
                        switch (this.item.object.id) {
                            case "BurgerKing_Minimum_Purchase":
                            case "BurgerKing_Buy_from_Specific_Category":
                            case "BurgerKing_Buy_Specific_Item":
                            case "BurgerKing_Ordered_X_Times_per_Day_Month":
                            case "BurgerKing_Accumulate_Purchase_by_Day_Month":
                            case "BurgerKing_Purchase_at_Date_and_Time":
                            default:
                                // Show popup to detail
                                this.notificationModal
                                    .clearModal()
                                    .show(this.item.type, { message: this.item.message }, this.item.isEarnReward)
                                    .subscribe((result) => {
                                        console.log(result)
                                    })
                                break;
                        }
                    }
                } else if (this.item.type == NotificationType.Badge  && this.item.isEarnReward) {
                
                    // Show popup to detail
                    this.handleTypeBadge(this.item)


                } else if (this.item.type == NotificationType.Campaign) {
                    this.tracking.event('notification','click notification list', `${this.item.object.ID ?? this.item.object.Id}|${this.item.object.Name}`,'Notification type campaign');

                    // show popup campaign
                    this.notificationModal
                        .clearModal()
                        .show(this.item.type, this.item.object)
                        .subscribe((result) => {
                            console.log(result)
                        })
                }
                else if (this.item.type == NotificationType.Link) {
                    // open link in new windows
                    window.open(this.item.object.url, "_blank")
                }
                else if (this.item.type == NotificationType.Category) {
                    let mainCat = null
                    // let subCat = null

                    if (!Utility.isEmptyStr(this.item.object.ParentId)) {
                        // TODO! not support sub cat yet
                        // mainCat = this.item.object.ParentId
                        // subCat = this.item.object.ID ?? this.item.object.Id
                        mainCat = this.item.object.ID ?? this.item.object.Id
                    } else {
                        mainCat = this.item.object.ID ?? this.item.object.Id
                    }
                    // go to product_detail
                    let urlParams = {
                        catId: mainCat,
                        // subCatId: subCat
                    }
                    urlParams = Utility.cleanObjectNullKey(urlParams)
                    this.$router.push({
                        name: "home",
                        params: urlParams
                    })
                } else {
                    // do nothing
                }
            }, 100);
        },
        handleTypeBadge: async function (notiItem) {
            var campaignId = notiItem?.object?.auto_redeem?.CampaignId;
            this.modal.loadingModal.show();
            var campaign = await this.getCampaignDetail(campaignId);
            this.modal.loadingModal.hide();
            this.notificationModal
                .clearModal()
                .setCampaign(campaign)
                .show(this.item.type, { message: this.item.message }, this.item.isEarnReward)
                .subscribe((result) => {
                    console.log(result)
                })
        },
        getCampaignDetail: function(campaignid) {
            var campaignConfig = new CampaignConfigBuilder()
                .setCampaignId(campaignid)
                .create();
            return new Promise((resolve) => {
                BzbsCampaign.apiGetCampaignDetail(campaignConfig).subscribe({
                    next: (data) => {
                        resolve(data);
                    },
                    error: (err) => {
                        this.modal.loadingModal.hide();
                        this.errorApi(err);
                    },
                });
            });
        }
    }
}
</script>

<style scoped lang="scss">
@import "@/style/base/text.scss";

.line-clamp-2 {
    @extend %ellipsis-2
}
</style>
